import { Tkv2MarketConditionsState } from '../types.ts';
import { CompTransactions } from './types.ts';

export function createCompTransactionsFromTkv2(
  comps: Tkv2MarketConditionsState['comps'],
  compSequence: string[],
): CompTransactions {
  return Object.fromEntries(
    compSequence.map((propID) => {
      const comp = comps[propID]?.property;
      const compStatus = comp?.getStructuredData('status');
      return [
        propID,
        {
          listingStatus: compStatus?.listingStatus,
          contractMonth: compStatus?.contractMonth,
          closeMonth: compStatus?.closeMonth,
        },
      ];
    }),
  );
}
